'use client';

import { Button } from '@nf/ui';
import { useTranslations } from 'next-intl';
import { useBetslipStore } from '@/store/betslip';
import { ArrowLeftIcon, Icon } from '@/components/icons/svg-icons';
import clsx from 'clsx';
import { betslipStyle } from '@/features/betslip/betslip.style';
import { useBetslipContext } from '../contexts/betslip-context';
import { useAccountInfo } from '@/hooks/query/account';
import { useAlertBetslip } from '../hook/use-alert-betslip';
import { betslipHeaderStyle } from './bet-slip-header.style';

export const BetslipModalHeader = () => {
	const t = useTranslations('General');
	const { user } = useAccountInfo();
	const { isIndependentMode } = useBetslipContext();
	const { showAlert } = useAlertBetslip(isIndependentMode);
	const [
		currentMultiTickets,
		removeAllTicket,
		toggleIsExpand,
	] = useBetslipStore(
		state => [
			state.currentMultiTickets,
			state.removeAllTicket,
			state.toggleIsExpand,
		]
	);
	const handleClearAll = () => {
		removeAllTicket();
		toggleIsExpand();
	};
	const closeModal = () => {
		toggleIsExpand();
	}
	const hasTicket = currentMultiTickets.length > 0;
	return (
		<div className={clsx('bet-slip-modal-header', betslipStyle.modalHeader)}>
			<Button variant="icon" onClick={toggleIsExpand} className={betslipStyle.backButton}>
				<ArrowLeftIcon />
			</Button>
			<div className={clsx('bet-slip-modal-header__title', betslipStyle.modalHeaderTitle)}>
				<div className={clsx('bet-slip-modal-header__title-text', betslipStyle.modalHeaderText)}>{t('Betsilp')}</div>
				{showAlert? (
					<div className={clsx('bet-slip-modal-header__title-alert-icon', betslipHeaderStyle.alertIcon)}>
						<Icon name="ticket-exclamation" />
					</div>
				): (hasTicket
					? <div className={clsx('bet-slip-modal-header__badge', betslipStyle.modalHeaderBadge)}>{currentMultiTickets.length}</div>
					: null
				)}
			</div>
			<div className={betslipStyle.modalHeaderTools}>
				{user ? (
					<div className={clsx('bet-slip-modal-header__available-funds', betslipStyle.availableFunds)}>
						<div>
							{t('lbl_FAvaliableFunds')}
						</div>
						<div>
							{user.BCredit}
						</div>
					</div>
					
				): null}
				<button className={clsx('bet-slip-modal-header__clean-button', betslipStyle.cleanAllButton)} onClick={handleClearAll}>
					<Icon name="trash-can" />
					<span className={clsx('clean-text', betslipStyle.cleanAllText)}>
						{t('lbl_ClearAll')}
					</span>
				</button>
				<Button
					variant="icon"
					onClick={closeModal}
					className={clsx('bet-slip-modal-header__collapse-button', betslipStyle.collapseButton)}
				>
					<Icon name={'collapse'} />
				</Button>
			</div>
		</div>
	)
}